function guestPermissionsDialog () {
  return {
    restrict: 'E',
    templateUrl: '/admin/dialogs/guest-permissions/guest-permissions-dialog.html?$$REVISION$$'
  }
}

export { guestPermissionsDialog }
